export default __webpack_public_path__ + "static/media/arbitrum.79164059.svg";